export enum DependsOnThenEnum {
  IsRequired = "IsRequired",
  Hide = "Hide",
  Disable = "Disable",
  AddValidations = "AddValidations",
  SetValue = "SetValue",
  SetFocus = "SetFocus"
}
